export default __webpack_public_path__ + "static/media/reference_gr_5.1831f5b2.svg";